<template>
<div class="row">
    <div class="col-md-6">
        <seccion-datos :titulo="companiastitulo" :botonGuardar="false" class="card card-warning">
            <div class="row">
                <div class="col-md-7">
                    <div class="input-group">
                        <select :disabled="!permisomodif" class="form-control" v-model="seleccionado">
                            <option value="">Seleccione una compañía</option>
                            <option v-for="compania in listado_companias" :key="compania.id" :value="compania.id">{{ compania.nombre }}
                                <p v-if="compania.prefijo">({{ compania.prefijo }})</p> 
                            </option>
                        </select>
                    </div>
                </div>
                        <div class="col-md-1">
                            <button :disabled="!permisomodif" class="btn btn-primary" @click="añadircompañia(seleccionado)">{{ $t('general.anadir') }}</button>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table table-sm table-striped">
                                <tbody>
                                    <tr v-for="oper in operario_compañia" :key="oper.idcompañia">
                                        <td> {{oper.nombre}}</td>
                                        <td align="right" >
                                            <div  class="col-xs-4">
                                                <button  :disabled="!permisomodif" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="eliminar(oper.idcompañia)">{{ $t('general.eliminar') }}</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> 
        </seccion-datos>
    </div>
</div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id','operario', 'permisomodif'],
    data() {
        return {
            listado_companias: [],
            seleccionado: '',
            operario_compañia: '',
            companiastitulo: "Compañías",
        }
    },
    methods: {
        async cargarDatosCompañias() {
            /* GET  modulos/pwgsapi/inde x.php/companias/simple */
            const api = new PwgsApi;
            const datos = await api.get('companias/simple',);
            this.listado_companias = datos.datos;
            this.companiastitulo = this.$t("general.companias");
            const datoss = await api.get('operarios/' + this.id + '/companias');
            this.operario_compañia = datoss.datos;
            this.operario_compañia.forEach(element => {
                this.listado_companias = this.listado_companias.filter(documento => documento.id != element.idcompañia);
            });
        },
        async eliminar(idcompañia) {  
            /* DELETE  modulos/pwgsapi/index.php/operarios/:id/companias/:id_compania */
            const api = new PwgsApi;
            await api.delete('operarios/' + this.id + '/companias/' + idcompañia);
            this.cargarDatosCompañias();

        },
        async añadircompañia(id) {
            /* POST  modulos/pwgsapi/index.php/operarios/:id/companias */
            let repetido = 0;
            if (this.operario_compañia.length > 1) {
                for (let opers of this.operario_compañia) {
                    if (id == opers.idcompañia) {
                        repetido = repetido + 1;
                    }
                }
            }
            if (repetido < 1) {
              //  const subidadatos = { id_companyia: id };
                const api = new PwgsApi;
                await api.post('operarios/' + this.id + '/companias/', {id_compania:id});
                this.cargarDatosCompañias();
                this.seleccionado = '';
            }
            
        }
    },
    watch: {
        id() {
            this.cargarDatosCompañias();
        }
    },
    mounted() {
        this.cargarDatosCompañias();
    }
}
</script>